import { render, staticRenderFns } from "./WaterfallSection.vue?vue&type=template&id=843f66f4&"
import script from "./WaterfallSection.vue?vue&type=script&lang=js&"
export * from "./WaterfallSection.vue?vue&type=script&lang=js&"
import style0 from "./WaterfallSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports